import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationKO from '../locales/ko/translation.json';
import translationEN from '../locales/en/translation.json';
import translationTH from '../locales/th/translation.json';
import translationJA from '../locales/ja/translation.json';

const resources = {
  ko: {
    translation: translationKO
  },
  en: {
    translation: translationEN
  },
  th: {
    translation: translationTH
  },
  ja: {
    translation: translationJA
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ko',
    debug: false,
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

// Apply custom translations after init
['ko', 'en', 'th', 'ja'].forEach(lang => {
  try {
    const custom = localStorage.getItem(`custom_i18n_${lang}`);
    if (custom) {
      const parsed = JSON.parse(custom);
      i18n.addResourceBundle(lang, 'translation', parsed, true, true);
    }
  } catch (e) {
    console.error(`Failed to load custom translations for ${lang}`, e);
  }
});

export const saveCustomTranslations = (lang: string, flattenedData: Record<string, string>) => {
  const unflatten = (data: Record<string, string>) => {
    const result: any = {};
    for (const key in data) {
      const parts = key.split('.');
      let current = result;
      for (let i = 0; i < parts.length - 1; i++) {
        if (!current[parts[i]]) current[parts[i]] = {};
        current = current[parts[i]];
      }
      current[parts[parts.length - 1]] = data[key];
    }
    return result;
  };

  const nestedData = unflatten(flattenedData);
  localStorage.setItem(`custom_i18n_${lang}`, JSON.stringify(nestedData));
  
  // Deep merge true, overwrite true
  i18n.addResourceBundle(lang, 'translation', nestedData, true, true);
  // Explicitly trigger a re-render by emitting event
  i18n.emit('languageChanged', i18n.language);
};

export default i18n;
